import useAlerts from "./useAlerts";

const useOnCloseWithConfirmation = (
  onClose: () => void,
  mustConfirm = false,
  confirmationTitle = "Are you sure you want to close this tab?",
  confirmationDescription = "All information will be lost."
) => {
  const alerts = useAlerts();

  return async () => {
    try {
      if (!mustConfirm) {
        return onClose();
      }

      const confirmed = await alerts.confirm(
        confirmationTitle,
        confirmationDescription
      );

      if (!confirmed) {
        return;
      }

      alerts.close();
      onClose();
    } catch (_) {
      onClose();
    }
  };
};

export default useOnCloseWithConfirmation;
